import { initialAsyncStatus } from './reducer';

/**
 * Return an async status object.
 * @param {Immutable Map} state
 * @param {Iterable} keyPath
 * @param {object?} notSetValue returned if the key is not defined in the async status map, default to initialAsyncStatus
 * @returns {Immutable Map} isRequesting, isComplete, error, cancellationSource
 */
export const getAsyncStatus = (state, keyPath, notSetValue = initialAsyncStatus) =>
	state.asyncStatus.getIn(keyPath, notSetValue);

/**
 * Return isComplete from specified async status object.
 * @param {Immutable Map} state
 * @param {Iterable} keyPath
 * @returns {boolean} selector, accepts state as its only parameter, returns boolean
 */
export const getIsComplete = (state, keyPath) => getAsyncStatus(state, keyPath).get('isComplete');

/**
 * Return isRequesting from specified async status object.
 * @param {Immutable Map} state
 * @param {Iterable} keyPath
 * @returns {boolean} isRequesting
 */
export const getIsRequesting = (state, keyPath) =>
	getAsyncStatus(state, keyPath).get('isRequesting');

/**
 * Return error from specified async status object.
 * @param {Immutable Map} state
 * @param {Iterable} keyPath
 * @returns {*} error
 */
export const getError = (state, keyPath) => getAsyncStatus(state, keyPath).get('error');
